//import * as Sentry from "@sentry/vue";
import axios from "axios";
import Vue from "vue";

const exploreGet = async (requestUrl, headers) => {
  return buildRequest(
    "get",
    `${Vue.prototype.$globalSettings.api_endpoint}/${requestUrl}`,
    headers
  );
};

const explorePost = async (requestUrl, data, headers) => {
  return buildRequest(
    "post",
    `${Vue.prototype.$globalSettings.api_endpoint}/${requestUrl}`,
    headers,
    data
  );
};

const explorePut = async (requestUrl, data, headers) => {
  return buildRequest(
    "put",
    `${Vue.prototype.$globalSettings.api_endpoint}/${requestUrl}`,
    headers,
    data
  );
};

const explorePatch = async (requestUrl, data, headers) => {
  return buildRequest(
    "patch",
    `${Vue.prototype.$globalSettings.api_endpoint}/${requestUrl}`,
    headers,
    data
  );
};

const exploreDelete = async (requestUrl, headers) => {
  return buildRequest(
    "delete",
    `${Vue.prototype.$globalSettings.api_endpoint}/${requestUrl}`,
    headers
  );
};

const authGet = async (requestUrl, headers) => {
  return buildRequest(
    "get",
    `${Vue.prototype.$globalSettings.auth_endpoint}/${requestUrl}`,
    headers
  );
};

const authPost = async (requestUrl, data, headers) => {
  return buildRequest(
    "post",
    `${Vue.prototype.$globalSettings.auth_endpoint}/${requestUrl}`,
    headers,
    data
  );
};

const authDelete = async (requestUrl, headers) => {
  return buildRequest(
    "delete",
    `${Vue.prototype.$globalSettings.auth_endpoint}/${requestUrl}`,
    headers
  );
};

const customPost = async (requestUrl, data, headers=null) => {
  return buildRequest("post", requestUrl, headers, data);
};

const customGet = async (requestUrl, data) => {
  return buildRequest("get", requestUrl);
};

const buildRequest = (method, url, headers = null, data = null) => {
  /*Sentry.setContext("API", {
    method,
    url,
    data
  });*/

  return axios({
    method,
    url,
    headers,
    data
  });
};

export default {
  exploreGet,
  explorePost,
  explorePut,
  explorePatch,
  exploreDelete,
  authGet,
  authPost,
  authDelete,
  customPost,
  customGet
};
